// extracted by mini-css-extract-plugin
export default {"ChatAppCard":"ChatApp_ChatAppCard__GqeQL","ChatApp":"ChatApp_ChatApp__JvQ5k","ChatFormCard":"ChatApp_ChatFormCard__lYgox"};